import { render } from "./edit.vue?vue&type=template&id=a390b1b0&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=a390b1b0&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a390b1b0"],['__file',"src/views/chess/tag/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a390b1b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a390b1b0', __exports__)) {
    console.log('reload')
    api.reload('a390b1b0', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=a390b1b0&scoped=true", () => {
    console.log('re-render')
    api.rerender('a390b1b0', render)
  })

}


export default __exports__